import * as THREE from 'three';
import Boid from './Boid.js';
import { clone } from 'three/examples/jsm/utils/SkeletonUtils.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { gsap } from "gsap";

export default class Birds{

  constructor(scene, glb, total = 10){

    this.birds = [];
    this.scene = scene;
    this.range = 30;
    this.total = total;

    this.boids = [];
    this.glb = glb;
    this.model = glb.scene;
    this.loader = new GLTFLoader();


  }

  async init(){


    for(let i = 0; i < this.total; i++){
      // create and position
      let r = this.range;
      let hr = r / 2;
      let p1 = new THREE.Vector3(Math.random()*r-hr, (Math.random()*hr/2)+hr, Math.random()*r-hr);

      let glbBird = clone(this.model);
      let bMesh = glbBird;
      bMesh.rotation.y = Math.PI;
      let b = new Boid();
      r = r / 2;
      hr = hr / 2;

      let angle = (Math.random() * (Math.PI*2));
      r = this.range + ( Math.random() - .5);
      let p  = new THREE.Vector3(r * Math.sin(angle),5, r * Math.cos(angle));

      b.init(bMesh, p,this.glb );
      b.cohesionFactor = Math.random()*0.02; //0.02
			b.alignmentFactor = Math.random()*0.02;
			b.separationFactor = Math.random()*0.03; //0.05
			b.centeringFactor = Math.random()*0.075;

      this.scene.add(bMesh);
      this.boids.push(b);
    //  this.scene.add(b.homeMesh);

    }


  }

  update(dt,seekTargets=[],lookAhead=null){

    for (let i in this.boids){

      let b = this.boids[i];

      b.homeMesh.position.copy(b.home);

      let seekTarget = null;
      if(seekTargets.length > i){
        seekTarget = seekTargets[i];
        b.seekTarget(seekTarget,dt,lookAhead);
      }else{
        b.step(dt,this.boids,seekTarget);
        if(b.isSeeking){
    			gsap.to(b.obj.mesh.scale,{x:1,y:1,z:1,duration:.5});
          if(b.seekT) b.seekTL.kill();
          gsap.to(b.Bird_RW.rotation,{x:0,y:0,duration:.2});
          gsap.to(b.Bird_LW.rotation,{x:0,y:0,duration:.2});

    		}

        b.isSeeking = false;

      }

    }

  }

  getTestBird(){
    const geometry = new THREE.BoxGeometry( .1, .1, .2 );
    const material = new THREE.MeshStandardMaterial( { color: 0xff0000 } );
    const mesh = new THREE.Mesh( geometry, material );
    return mesh;
  }



};
